import { captureMessage, captureException, isInitialized } from '@sentry/react'
import { CheckInternet } from 'shared/store/CheckInternet'
import { checkSampleRate } from 'entities/Sentry/lib/checkSampleRate'

export type ISentrySentEventProps = {
  event: string
  level: 'fatal' | 'error' | 'warning' | 'log' | 'debug' | 'info'
  error?: Error | unknown
  name: string
  tags?: {
    [key in string]: number | string | boolean | bigint | symbol | null | undefined
  }
  fingerprint?: string[]
  extra?: Record<string, unknown>
  sampleRate?: number
}

export const sentEventSentry = ({
  event,
  error,
  level,
  name,
  tags,
  fingerprint,
  extra,
  sampleRate = 1,
}: ISentrySentEventProps) => {
  if (!isInitialized()) return null

  if (!checkSampleRate(sampleRate)) return null

  if (error instanceof Error) {
    captureException(error, {
      level: 'error',
      tags: {
        'app.service': name,
        'app.event': event,
        enableInternet: CheckInternet.isOnline,
        sampleRate: sampleRate,
        ...tags,
      },
      fingerprint: fingerprint,
      extra: extra,
    })
  } else {
    captureMessage(event, {
      level: level,
      tags: {
        'app.service': name,
        'app.event': event,
        enableInternet: CheckInternet.isOnline,
        sampleRate: sampleRate,
        ...tags,
      },
      fingerprint: fingerprint,
      extra: extra,
    })
  }
}
